import { render } from "./portInfo.vue?vue&type=template&id=c0a7faf0"
import script from "./portInfo.vue?vue&type=script&lang=js"
export * from "./portInfo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\e2efreight\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__